import { accountableAPI, isProduction } from 'config';
import useGetLoggedInUserData from 'hooks/Authentication/useGetLoggedInUserData';
import { useState, type FC } from 'react';
import { GROWTH_ALLOWED_EMAILS } from 'utils/constants';

import GearIcon from 'assets/svg/icons/gearIcon';
import { Button } from 'components/atoms/Button';
import SlideOver2 from 'components/molecules/SlideOver2.component';
import { AnimatePresence } from 'motion/react';
import { createPortal } from 'react-dom';
import colors from 'theme/colors';
import { XIcon } from 'utils/icons';
import ENVSwitcher from './ENVSwitcher';
import GrowthExperiments from './GrowthExperiments';

const DevToolsComponents: FC = () => {
  const [open, setOpen] = useState(false);
  const [envName, setEnvName] = useState(
    accountableAPI.baseUrl?.split('https://')?.[1].split('.')[0],
  );
  const handleVerticalDrag = (event: any) => {
    event.target.style.top =
      event.clientY > window.innerHeight
        ? '95%'
        : event.clientY < 0
        ? '5%'
        : event.clientY + 'px';
  };

  return (
    <>
      {createPortal(
        <Button
          draggable
          onDrag={handleVerticalDrag}
          iconPlacement="right"
          className="h-8 z-[500] transition-none !rounded-r-none bg-white shadow-filters flex justify-center items-center fill-current group transition-colors fixed top-[95%] right-0"
          onClick={() => setOpen((prev) => !prev)}
        >
          {open ? (
            <XIcon className="text-revenues h-5 transition-colors" />
          ) : (
            <GearIcon stroke={colors.revenues.DEFAULT} />
          )}
          <span className="text-xs px-0.5 text-revenues capitalize font-bold">
            {envName}
          </span>
        </Button>,
        document.body,
      )}
      <AnimatePresence mode="wait">
        {open ? (
          <SlideOver2
            renderRightPanel={() => (
              <div className="px-4 py-6">
                <ENVSwitcher envName={envName} setEnvName={setEnvName} />
                <GrowthExperiments />
              </div>
            )}
          />
        ) : null}
      </AnimatePresence>
    </>
  );
};

export default function DevTools() {
  const user = useGetLoggedInUserData().data;

  const isAllowedEmail =
    !!user?.email &&
    (GROWTH_ALLOWED_EMAILS.includes(user.email) ||
      user.email.includes('@accountable.eu'));

  if (isProduction && !isAllowedEmail) return null;

  return <DevToolsComponents />;
}
